export const mappings = [
	'actions',
	'labels',
	'forms',
	'errors',
	'tiers',
	'coordonnes-bancaires',
	'documents',
	'commentaire',
	'benefEffectif',
	'preferences'
];
